import { styled } from "src/styles/theme";

export const Input = styled("input", {
  applyReset: "input",
  width: 120,
  padding: "0 $2 0 0",
  border: 0,
  color: "$neutralText",
  fontSize: "$base",

  '&[type="date"]': {
    width: "140px",
  },

  "&:focus": {
    outline: 0,
  },

  "&::placeholder": {
    color: "$neutral7",
  },

  variants: {
    format: {
      code: {
        width: 280,
        fontFamily: "$mono",
        fontSize: "$sm",
      },
    },
  },
});
